import {
  Card,
  CardContent,
  Typography,
  Stack,
  Box,
  Button,
  Divider,
} from "@mui/material";
import { Home, FileText, MapPin, CalendarDays, ArrowRight } from "lucide-react";
import { NavLink } from "react-router-dom";

const textColor = "#0d2561";
const itextColor = "#707070";

export function MarketplaceOpportunitiesWidget() {
  const opportunities = [
    { id: 1, type: "Property", count: 2, date: "June 6", location: "New York" },
    { id: 2, type: "RFP", count: 1, date: "June 6", location: "New York" },
  ];

  return (
    <Card elevation={2} sx={{ borderRadius: 2 }}>
      <CardContent>
        <Typography variant="h6" sx={{ color: textColor, mb: 1 }}>
          Marketplace Opportunities
        </Typography>
        <Typography variant="body2" sx={{ color: itextColor, mb: 2 }}>
          Explore new properties and RFPs listed in your area.
        </Typography>

        <Stack spacing={2}>
          {opportunities.map((opportunity) => (
            <Box key={opportunity.id} display="flex" gap={2}>
              <Box mt={0.5}>
                {opportunity.type === "Property" ? (
                  <Home size={20} color={textColor} />
                ) : (
                  <FileText size={20} color={itextColor} />
                )}
              </Box>
              <Box>
                <Typography
                  variant="body2"
                  fontWeight={500}
                  sx={{ color: textColor }}
                >
                  {opportunity.count} {opportunity.type}
                  {opportunity.count > 1 ? "s" : ""} posted
                </Typography>

                <Box display="flex" alignItems="center" mt={0.5}>
                  <CalendarDays size={12} color={textColor} />
                  <Typography variant="caption" sx={{ color: textColor, ml: 0.5 }}>
                    Date: {opportunity.date}
                  </Typography>

                  <Typography variant="caption" sx={{ mx: 1, color: textColor }}>
                    |
                  </Typography>

                  <MapPin size={12} color={textColor} />
                  <Typography variant="caption" sx={{ color: textColor, ml: 0.5 }}>
                    {opportunity.location}
                  </Typography>
                </Box>
              </Box>
            </Box>
          ))}
        </Stack>

        

        <Box textAlign="right">
          <NavLink to="#" style={{ textDecoration: "none" }}>
            <Button
              variant="text"
              size="small"
              sx={{ color: textColor, textTransform: "none", fontSize: "0.875rem" }}
              endIcon={<ArrowRight size={16} />}
            >
              View all opportunities
            </Button>
          </NavLink>
        </Box>
      </CardContent>
    </Card>
  );
}
